<!-- CKCCIcon.vue -->
<script setup lang="ts">
import { CKCCStatusType } from '../../../Enums/ChoiceEnums';
import { computed } from 'vue';
import { ImageType, choiceImageTypeUrls } from '../../../lib/OfficeMd/images';
import { htmlDecode } from '../../../lib/ChoiceUtils';

    const props = defineProps<{
        status?: CKCCStatusType,
        tooltip?: string,
        class?: string
    }>();

    const imageUrl = computed(() =>{
        switch(props.status)
        {
            case CKCCStatusType.PatientEnrolled:
                return choiceImageTypeUrls[ImageType.CKCCEnrolled];
            case CKCCStatusType.ProgramExistButPatientNotEnrolled:
                return choiceImageTypeUrls[ImageType.CKCCProgramExistButPatientNotEnrolled];
        }
    });

    const cleanToolTip = computed(() => htmlDecode(props.tooltip));
</script>

<template>
    <img v-if="imageUrl" 
            :src="imageUrl" 
            :title="cleanToolTip" 
            :alt="cleanToolTip" 
            :class="class" />
</template>